module.exports = __webpack_public_path__ + "static/media/logo.d133b679.png";